import { useState } from "react"
import { useTranslation } from "react-i18next"

import TabCoach from "@/app/settings/club/coaches/CoachTab"
import InvitationTab from "@/app/settings/club/components/invitation/invitationTab/InvitationTab"
import Tab from "@/components/tab/Tab"
import { AccountTypeKey } from "@/constants/account"
import "./coaches.scss"

export default function Page() {
  const { t } = useTranslation("")
  const tabList = [
    {
      label: t("joined"),
      value: "joined",
    },
    {
      label: t("invite"),
      value: "invitation",
    },
  ]

  const [value, setValue] = useState<string | number>(tabList[0].value)

  return (
    <div className="CoachesCont">
      <Tab
        type="filled"
        list={tabList}
        value={value}
        onChange={(_, newValue: string | number) => {
          setValue(newValue)
        }}
      />
      {value === tabList[0].value && (
        <div role="tabpanel">
          <TabCoach />
        </div>
      )}
      {value === tabList[1].value && (
        <div role="tabpanel">
          <InvitationTab type={AccountTypeKey.Coach} />
        </div>
      )}
    </div>
  )
}
